/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: queue-limiter-edit-controller.js
 *
 * Created by psnyder on 3/1/17.
 */
'use strict';

angular.module('prism-ui.queues').controller('QueueLimiterEditController',
	function ($uibModalInstance, limiterId, queueMaxActive, QueuesViewService) {
		var self = this;

		self.loadingIndicator = {
			backdrop: true,
			show: false,
			title: 'Working',
			message: 'Please wait...'
		};

		var filterCategoryTypeDropdown = function () {
			var allCategoryTypes = angular.copy(self.categoryTypes);
			var tempCategoryTypeLimiters = [];
			var tempPartnerCatTypeLimiters = [];

			QueuesViewService.queueLimiters.forEach(function (limiter) {
				if (limiter.categoryType && !limiter.partner) {
					tempCategoryTypeLimiters.push(limiter);
				}
				else if (limiter.categoryType && limiter.partner) {
					tempPartnerCatTypeLimiters.push(limiter);
				}
			});
			if (!self.limiterObject.partner) {
				allCategoryTypes.forEach(function (catType, index) {
					tempCategoryTypeLimiters.forEach(function (catTypeLimiter) {
						if (catTypeLimiter.categoryType &&
							catTypeLimiter.categoryType.name === catType.name) {
							allCategoryTypes.splice(index, 1);
						}
					});
				});
			} else {
				tempPartnerCatTypeLimiters.forEach(function (partnerLimiter) {
					if (partnerLimiter.partner.name === self.limiterObject.partner.name) {
						allCategoryTypes.forEach(function (catType, index) {
							if (catType.name === partnerLimiter.categoryType.name) {
								allCategoryTypes.splice(index, 1);
							}
						});
					}
				});
			}
			return allCategoryTypes;
		};

		var filterPartnerDropdown = function () {
			var tempPartnersList = angular.copy(self.partnersList);
			for (var partnerIndex = tempPartnersList.length - 1; partnerIndex >= 0; partnerIndex--) {
				var hasShortForm = false;
				var hasLongForm = false;
				var hasPartnerGlobal = false;
				var partnerSpliced = false;
				for (var limiter = 0; limiter < QueuesViewService.queueLimiters.length; limiter++) {
					if (!partnerSpliced && QueuesViewService.queueLimiters[limiter].partner &&
						tempPartnersList[partnerIndex].name === QueuesViewService.queueLimiters[limiter].partner.name) {
						if (!QueuesViewService.queueLimiters[limiter].categoryType) {
							hasPartnerGlobal = true;
							tempPartnersList.splice(partnerIndex, 1);
							partnerSpliced = true;
						}
						if (!hasPartnerGlobal) {
							if (QueuesViewService.queueLimiters[limiter].categoryType.name === 'Long Form') {
								hasLongForm = true;
							}
							if (QueuesViewService.queueLimiters[limiter].categoryType.name === 'Short Form') {
								hasShortForm = true;
							}
							if (hasLongForm && hasShortForm) {
								tempPartnersList.splice(partnerIndex, 1);
								partnerSpliced = true;
							}
						}
					}
				}
			}
			if (self.limiterObject.categoryType) {
				QueuesViewService.queueLimiters.forEach(function (queueLimiter) {
					if (queueLimiter.categoryType && queueLimiter.partner && queueLimiter.categoryType.name === self.limiterObject.categoryType.name) {
						for (var tempPartner = tempPartnersList.length - 1; tempPartner >= 0; tempPartner--) {
							if (tempPartnersList[tempPartner].name === queueLimiter.partner.name) {
								tempPartnersList.splice(tempPartner, 1);
							}
						}
					}
				});
			}
			return tempPartnersList;
		};

		self.filterEditDropdowns = function () {
			self.partners = filterPartnerDropdown();
			self.catTypes = filterCategoryTypeDropdown();
		};

		self.getLimiterEditData = function () {
			self.loadingIndicator.show = true;
			QueuesViewService.getLimiterEditData(limiterId).then(function (data) {
				if (data.limiter) {
					self.limiterObject = data.limiter;
					self.limiterObject.maxActive = parseInt(self.limiterObject.maxActive);
				} else {
					self.limiterObject = {maxActive: 1};
				}
				self.partnersList = data.partners;
				self.categoryTypes = data.categoryTypes;
				self.maxActiveLimit = parseInt(queueMaxActive);
				self.tempQueueLimiters = QueuesViewService.queueLimiters;
				self.filterEditDropdowns();

				self.loadingIndicator.show = false;
			});
		};

		self.onMaxActiveChange = function () {
			self.limiterObject.maxActive = parseInt(self.limiterObject.maxActive);
		};

		self.maxActiveInvalid = function () {
			return !self.limiterObject.maxActive || self.limiterObject.maxActive > self.maxActiveLimit || self.limiterObject.maxActive < 1;
		};

		self.disableOkButton = function () {
			return !self.limiterObject || self.maxActiveInvalid() ||
				   (!self.limiterObject.partner && !self.limiterObject.categoryType) || self.modalForm.$pristine;
		};

		self.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};

		self.onOk = function () {
			if (limiterId < 0) {
				delete self.limiterObject.id;
			}
			$uibModalInstance.close(self.limiterObject);
		};

		self.getLimiterEditData();

	});
